<template>
    <div class="is-full-width">
        <div class="is-flex is-flex-direction-row is-flex-wrap-nowrap is-full-height">
            <div class="is-flex-grow-0 px-6" style="flex-basis: 15%;">
                <div class="is-flex is-justify-content-center">
                    <span class="is-clickable" @click="selectNewDate(selectedDate.year - 1, selectedDate.month)">
                        <ArrowDown class="icon_arrow_down mr-4" />
                    </span>
                    <span class="mt-1 text_year">{{ selectedDate.year }}</span>
                    <span class="is-clickable" :class="{ 'is-disabled-local': now && selectedDate.year > now.year() }"
                        @click="selectNewDate(selectedDate.year + 1, selectedDate.month)">
                        <ArrowDown class="icon_arrow_down rotate_arrow ml-4" />
                    </span>
                </div>
                <div v-for="(month, iMonth) in listMonthsNames" :key="month">
                    <div class="month_btn mb-2 is-flex is-justify-content-start" :class="{
                        'is-disabled-local': isMonthGreaterThanNow(iMonth),
                        'is-selected': month == selectedDate.month,
                        ' is-clickable': !isMonthGreaterThanNow(iMonth)
                    }" @click="selectNewDate(selectedDate.year, month)">
                        <component
                            v-if="!allMonthsData[selectedDate.year + '_' + month] || !allMonthsData[selectedDate.year + '_' + month].id || allMonthsData[selectedDate.year + '_' + month].has_error"
                            :is="'FileAlone'">
                        </component>
                        <component v-else :is="'FileCheck'"></component>
                        <!-- <FileAlone /> -->
                        <span class="is-capitalized text_month ml-1">{{ month }}</span>
                    </div>
                </div>
            </div>
            <div class="is-flex-grow-0 border_left px-6" style="flex-basis: 85%;">
                <div class="is-flex is-flex-direction-row is-full-width is-justify-content-space-between is-align-items-center">
                    <div class="is-flex-grow-3">
                        <p class="tittleContent"> {{ selectedTypeFile.label }} de
                            <span class="is-capitalized">
                                {{ selectedDate.month }}
                            </span> {{ selectedDate.year }}
                        </p>
                        <p class="subTittleContent mb-1">
                            {{ selectedTypeFile.subTittle }}
                        </p>
                    </div>
                </div>

                <div class="is-flex is-flex-direction-row p-4 template_box">
                    <div style="flex-basis: 5%;" class="mr-1">
                        <span class="info_circle">
                            <InfoCircle class="" />
                        </span>
                    </div>
                    <div style="flex-basis: 95%;">
                        <p class="tittle"> {{ selectedTypeFile.alertTittle }} </p>
                        <p class="sub_tittle"> {{ selectedTypeFile.alertSubTittle }} </p>
                        <div class="is-flex mt-3">
                            <div class="download_btn is-flex is-justify-content-start is-clickable"
                                @click="downloadTemplateByTypeFile()">
                                <component :is="'DownloadFile'"></component>
                                <span class="text_month ml-1">Descargar Plantilla</span>
                            </div>
                            <div v-if="selectedTypeFile.value != 'finiquitos-clf'"
                                class="download_btn is-flex is-justify-content-start ml-2" :class="{
                                    'is-disabled-local': !previousMonth || !previousMonth.url_drive,
                                    'is-clickable': previousMonth && previousMonth.url_drive
                                }" @click="downloadFile(previousMonth.url_drive, previousMonth.file_name)">
                                <component :is="'DownloadFile'"></component>
                                <span class="text_month ml-1">Mes anterior</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="is-flex is-flex-direction-row mt-4 p-4 file_box"
                    :class="[isError ? 'box_color_error' : 'box_color_normal', { 'is-disabled-local': isUploadingFile }]">
                    <div style="flex-basis: 5%;" class="mr-1">
                        <span class="">
                            <FileXLS v-if="!isError && isFileUploaded" />
                            <Page v-if="isError || !isFileUploaded" />
                        </span>
                    </div>
                    <div style="flex-basis: 95%;" class="is-flex is-flex-direction-row">
                        <div style="min-width: 40%;" class="is-flex is-flex-direction-column is-justify-content-center">
                            <p v-if="!isFileUploaded" class="tittle">Subir {{ selectedTypeFile.label }} </p>
                            <p v-if="isFileUploaded" class="tittle">
                                {{ selectedMonthFile.file_name }}
                            </p>
                            <p v-if="!isError && isFileUploaded" class="sub_tittle">
                                Archivo cargado: {{ getDateByFormat(selectedMonthFile.update_at, "D, MMMM YYYY") }}
                                | Tamaño: {{ selectedMonthFile.size_kb }} KB
                            </p>
                            <p v-if="isError && isFileUploaded" class="sub_tittle">Error en el archivo</p>
                        </div>
                        <div class="is-full-width is-flex is-justify-content-end is-align-items-center">
                            <span class="download_btn is-flex is-justify-content-center is-clickable mr-2"
                                @click="$refs.fileInput.click()">
                                <span class=" mr-2">
                                    <Refresh v-if="isFileUploaded" class="svg_icon" />
                                    <UploadFile v-if="!isFileUploaded" class="svg_icon" />
                                </span>
                                <span v-if="isFileUploaded">Actualizar</span>
                                <span v-else>Subir Documento</span>
                                <input ref="fileInput" type="file" accept=".xls, .xlsx" class="is-hidden"
                                    @change="handleFile" />
                            </span>
                            <span v-if="isFileUploaded"
                                @click="downloadFile(selectedMonthFile.url_drive, selectedMonthFile.file_name)"
                                class="download_btn is-clickable mr-2">
                                <DownloadFile class="svg_icon" />
                            </span>
                            <span v-if="isFileUploaded" @click="openConfirmRestoreModal()"
                                class="download_btn is-clickable">
                                <Trash class="svg_icon" />
                            </span>
                        </div>
                    </div>
                </div>
                <div class="is-full-width mt-3" :class="{ 'is-disabled-local': isUploadingFile }">
                    <RemunerationsDocsTable v-if="!isError && isFileUploaded"
                        :tax_documents="selectedMonthFile.tax_documents" @reloadData="changeYear()" />
                    <MsgToUploadFile v-else :isError="isError" :msgError="selectedMonthFile.msg_error" />
                </div>
            </div>
        </div>
        <input ref="fileInputMassive" type="file" accept=".xls, .xlsx" class="is-hidden"
            @change="(event)=>handleFile(event, true, true)" />
    </div>
</template>
<script>
import ArrowDown from "@/components/svg/ArrowDown.vue";
import DownloadFile from "@/components/svg/DownloadFile.vue";
import FileAlone from "@/components/svg/FileAlone.vue";
import FileCheck from "@/components/svg/FileCheck.vue";
import FileXLS from "@/components/svg/FileXLS.vue";
import InfoCircle from "@/components/svg/InfoCircle.vue";
import Page from "@/components/svg/Page.vue";
import Refresh from "@/components/svg/Refresh.vue";
import Trash from "@/components/svg/Trash.vue";
import UploadFile from "@/components/svg/UploadFile.vue";

import { deleteFileMonth, getAllFilesUploadedByYear, getUrlsDownloadFile, uploadFileExcel } from "@/api/uploadFiles";
import ConfirmRestore from "@/components/modals/ConfirmRestore";
import { notificate } from "@/utils/message";
import moment from "moment";
import { mapActions, mapState } from "vuex";
import MsgToUploadFile from "../MsgToUploadFile.vue";
import RemunerationsDocsTable from "../RemunerationsDocsTable.vue";

export default {
    name: "BodyUploadDocs",
    components: {
        ArrowDown,
        FileAlone,
        FileCheck,
        DownloadFile,
        InfoCircle,
        FileXLS,
        Trash,
        Refresh,
        Page,
        UploadFile,
        RemunerationsDocsTable,
        MsgToUploadFile,
    },
    data() {
        return {
            now: null,
            hasCheckedInitialMassive: false,
            massiveFileToUpload: null,
            listMonthsNames: moment.months(),
            allMonthsData: {},
            selectedMonthFile: {},
            previousMonth: {},
            isUploadingFile: false,
            modalDefault: {
                parent: this,
                width: "25%",
                hasModalCard: true,
                canCancel: ["escape", 'button', "outside"],
                customClass: "center-always-modal",
            },
        };
    },
    computed: {
        ...mapState("uploadFiles", ["selectedDate", "selectedTypeFile"]),
        isFileUploaded() {
            return this.selectedMonthFile && this.selectedMonthFile.id
        },
        isError() {
            return this.selectedMonthFile && this.selectedMonthFile.has_error
        }
    },
    mounted() {
        this.now = moment()
        this.setNewSelectedDate({
            year: this.now.year(),
            month: moment.months(this.now.month())
        })

        this.changeYear()
        this.setLastMonth()
    },
    methods: {
        ...mapActions("uploadFiles", ["setNewSelectedDate"]),
        isMonthGreaterThanNow(month) {
            const now = moment()
            const actualMonth = moment({ year: this.selectedDate.year, month: month })
            return now.isBefore(actualMonth)
        },
        getDateByFormat(date, format) {
            const newDate = moment(date);
            return newDate.format(format);
        },
        selectNewDate(newYearSelected, newMonthSelected) {
            if (newYearSelected > this.now.year() + 1) {
                return
            }
            const actualSelected = this.selectedDate.year
            const actualMonthSelected = this.selectedDate.month
            this.setNewSelectedDate({
                year: newYearSelected,
                month: newMonthSelected
            })
            if (newYearSelected != actualSelected) {
                this.changeYear()
            } else if (newMonthSelected != actualMonthSelected) {
                this.changeMonth()
            }
        },
        handleFile(event, isMassive=false, isDryRun=false) {
            this.isUploadingFile = true
            let file = null;
            if (event) {
                file = event.target.files[0];
                if (isMassive) {
                    this.massiveFileToUpload = file;
                }
            } else if (isMassive && this.massiveFileToUpload) {
                file = this.massiveFileToUpload;
            }

            if (file) {
                const formData = new FormData();
                if (!isMassive && this.selectedMonthFile.id) {
                    formData.append('excel_file_id', this.selectedMonthFile.id);
                }
                formData.append('excel_file', file);
                formData.append('is_massive', isMassive);
                
                if (isMassive && isDryRun) {
                    formData.append('dry_run', true);
                }
                formData.append('type', this.selectedTypeFile.value);
                formData.append('year_file', this.selectedDate.year);
                formData.append('month_file', this.selectedDate.month);
                uploadFileExcel(formData).then(({ data }) => {
                    if (data.is_dry_run) {
                        this.isUploadingFile = false;
                        this.openDryRunModal(data.summary);
                        this.$refs.fileInputMassive.value = '';
                        return;
                    }

                    if (isMassive) {
                        this.changeYear()
                    } else {
                        this.allMonthsData[this.selectedDate.year + '_' + this.selectedDate.month] = { ...data }
                        this.selectedMonthFile = { ...data }
                    }
                    notificate(
                        `<strong>Éxito!</strong><br>
                        Documento cargado con éxito`,
                        "is-success is-light"
                    );
                }).catch((error) => {
                    if (error.response && error.response.data && error.response.data.is_dry_run && error.response.data.has_error) {
                        this.openDryRunModal([], error.response.data.msg_error);
                    }
                }).finally(() => {
                    this.isUploadingFile = false;
                    this.$refs.fileInput.value = '';
                    this.$refs.fileInputMassive.value = '';
                })

            }
        },
        downloadTemplateByTypeFile() {
            this.downloadFile(this.selectedTypeFile.TEMPLATE, this.selectedTypeFile.nameTemplate)
        },
        setLastMonth() {
            let currentIndex = this.listMonthsNames.indexOf(this.selectedDate.month);
            let usedYear = this.selectedDate.year
            if (currentIndex <= 0) {
                currentIndex = this.listMonthsNames.length
                usedYear -= 1
            }
            const previousMonthName = this.listMonthsNames[currentIndex - 1];
            this.previousMonth = this.allMonthsData[usedYear + '_' + previousMonthName] || {}
        },
        downloadFile(drive_id, file_name) {
            if (!drive_id) return;
            getUrlsDownloadFile({
                drive_id,
                file_name,
            }).then(({ data }) => {
                let url = data.url_download
                url = url.match(/^https?:/) ? url : '//' + url;
                window.open(url)
            })
        },
        changeYear() {
            getAllFilesUploadedByYear({
                'year': this.selectedDate.year,
                'type': this.selectedTypeFile.value
            }).then(({ data }) => {
                const allSpreadsheetByYear = data.spreadsheet_data
                const allMonths = this.listMonthsNames
                const allDataMonths = {}
                allMonths.forEach(month => {
                    allDataMonths[this.selectedDate.year + '_' + month] = {}
                })
                allSpreadsheetByYear.forEach(data => {
                    allDataMonths[data.year_file + '_' + data.month_file] = data
                })

                this.allMonthsData = { ...allDataMonths }
                this.selectedMonthFile = this.allMonthsData[this.selectedDate.year + '_' + this.selectedDate.month]
                this.setLastMonth()
                if (!this.hasCheckedInitialMassive) {
                    this.hasCheckedInitialMassive = true;
                    this.checkMassiveUploadModal()
                }
            })
        },
        changeMonth() {
            this.selectedMonthFile = this.allMonthsData[this.selectedDate.year + '_' + this.selectedDate.month]
            this.setLastMonth()
        },
        deleteSelectedFile() {
            deleteFileMonth(this.selectedMonthFile.id).then(() => {
                this.allMonthsData[this.selectedDate.year + '_' + this.selectedDate.month] = {}
                this.selectedMonthFile = {}
            })
        },
        openConfirmRestoreModal() {
            this.$buefy.modal.open({
                ...this.modalDefault,
                component: ConfirmRestore,
                props: {
                    eventNameConfirmRestore: 'deleteFile',
                    tittleRestore: '¿Estás seguro de eliminar este documento?',
                    subTittleRestore: 'Esta acción eliminará el documento de libro de remuneraciones de ',
                    endSubTittleBold: this.selectedDate.month + ' ' + this.selectedDate.year,
                    msgOkAction: 'Eliminar Archivo'
                },
                events: {
                    deleteFile: () => {
                        this.deleteSelectedFile()
                    }
                },
            });
        },
        checkMassiveUploadModal() {
            let allMissing = true;
            for (let i = 0; i < 3; i++) {
                const targetMoment = moment().subtract(i, 'months');
                const key = targetMoment.year() + '_' + this.listMonthsNames[targetMoment.month()];
                const fileData = this.allMonthsData[key];
                
                if (fileData && fileData.id && fileData.tax_documents.length>0) {
                    allMissing = false;
                    break;
                }
            }

            if (allMissing) {
                this.openMassiveUploadModal();
            }
        },
        openMassiveUploadModal() {
            this.$buefy.modal.open({
                ...this.modalDefault,
                component: ConfirmRestore,
                props: {
                    eventNameConfirmRestore: 'openMassiveUpload',
                    tittleRestore: '¿Subir múltiples meses?',
                    subTittleRestore: 'Al parecer no has subido '+this.selectedTypeFile.label+' en los últimos 3 meses. Puedes subirlos de forma masiva en un solo archivo.',
                    endSubTittleBold: '',
                    msgOkAction: 'Subir archivo masivo',
                    cancelText: 'Subir un mes',
                    btnClass: 'is-primary',
                    headerIconBgClass: 'has-background-info-light',
                    iconComponent: UploadFile
                },
                events: {
                    openMassiveUpload: () => {
                        this.$refs.fileInputMassive.click();
                    }
                },
            });
        },
        openDryRunModal(summary, msgError = null) {
            let tittleRestore = '¿Confirmar Sobreescritura Masiva?';
            let subTittleRestore = '';
            let endSubTittleBold = ' ¿Proceder?';
            let msgOkAction = 'Confirmar y Guardar';
            let btnClass = 'is-info';
            let headerIconBgClass = 'has-background-warning-light';

            if (msgError) {
                tittleRestore = 'Error en el Archivo';
                subTittleRestore = msgError;
                endSubTittleBold = ' Por favor, modifica el archivo e inténtalo de nuevo.';
                msgOkAction = 'Volver a intentar';
                btnClass = 'is-danger';
                headerIconBgClass = 'has-background-danger-light';
            } else {
                let monthOverwrites = summary.map(item => `${item.month} ${item.year} (${item.old_docs_count} viejos → ${item.new_docs_count} nuevos)`).join(' | ');
                if (summary.length === 0) {
                    monthOverwrites = "No se detectaron meses procesables en tu documento.";
                }
                subTittleRestore = 'Si continúas, los siguientes meses serán limpiados por completo y sobreescritos por el archivo: ' + monthOverwrites;
            }

            this.$buefy.modal.open({
                ...this.modalDefault,
                component: ConfirmRestore,
                props: {
                    eventNameConfirmRestore: msgError ? 'retryMassiveUpload' : 'confirmMassiveUpload',
                    tittleRestore: tittleRestore,
                    subTittleRestore: subTittleRestore,
                    endSubTittleBold: endSubTittleBold,
                    msgOkAction: msgOkAction,
                    cancelText: 'Cancelar',
                    btnClass: btnClass,
                    headerIconBgClass: headerIconBgClass,
                    iconComponent: msgError ? Page : UploadFile
                },
                events: {
                    confirmMassiveUpload: () => {
                        this.handleFile(null, true, false);
                    },
                    retryMassiveUpload: () => {
                        this.$refs.fileInputMassive.click();
                    }
                },
            });
        },
    }
}
</script>
<style scoped lang="scss">
.border_left {
    border-left: 1px solid #EAECF0;
}

.svg_icon {
    width: 20px;
    height: 20px;
    margin-bottom: -4px;
}

.icon_arrow_down {
    width: 30px;
    height: 30px;
    fill: grey;
    transform: rotate(90deg);
}

.rotate_arrow {
    transform: rotate(270deg);
}

.text_year {
    color: var(--Gray-700, #344054);
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
}

.month_btn {
    border-radius: 6px;
    border: 1px solid #D0D5DD;
    background: #FFF;
    padding: 8px 12px;

    .text_month {
        color: #002E33;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
    }
}

.month_btn:hover,
.is-selected {
    border-radius: 6px;
    border: 1px solid #00A9AD;
    background-color: #EFFEFD;
    color: #00A9AD;
}

.tittleContent {
    color: var(--Gray-900, #101828);
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
}

.subTittleContent {
    color: var(--Gray-600, #475467);
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
}

.template_box {
    border-radius: 12px;
    border: 1px solid #90FFF5;
    background: #EFFEFD;
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);

    .info_circle {
        width: 40px;
        height: 40px;
        background-color: #1DE4E1;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .tittle {
        color: #002E33;
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
    }
}

.file_box {
    border-radius: 12px;

    .tittle {
        color: #344054;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
    }
}

.box_color_normal {
    border: 1px solid var(--Gray-200, #EAECF0);
    background-color: var(--Base-White, #FFF);
}

.box_color_error {
    border: 1px solid #FECDCA;
    background-color: #FEF3F2;
}

.sub_tittle {
    color: #475467;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
}

.download_btn {
    border-radius: 8px;
    border: 1px solid var(--Gray-300, #D0D5DD);
    background: var(--Base-White, #FFF);
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    padding: 10px 14px;
    max-width: fit-content;

    color: var(--Gray-700, #344054);
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
}
</style>